<template>
  <div class="card card-custom">
    <div v-if="!currentUser.is_verify" class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-1"
        id="kt_wizard_v1"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav-->
        <div class="wizard-nav border-bottom">
          <div class="wizard-steps p-8 p-lg-10">
            <div
              class="wizard-step"
              data-wizard-type="step"
              data-wizard-state="current"
            >
              <div class="wizard-label">
                <i class="wizard-icon flaticon-bus-stop"></i>
                <h3 class="wizard-title">1. 填写认证资料</h3>
              </div>
              <i class="wizard-arrow flaticon2-next"></i>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-label">
                <i class="wizard-icon flaticon-list"></i>
                <h3 class="wizard-title">2. 确认认证信息</h3>
              </div>
              <i class="wizard-arrow flaticon2-next"></i>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-label">
                <i class="wizard-icon flaticon-responsive"></i>
                <h3 class="wizard-title">3. 支付宝扫码</h3>
              </div>
              <i class="wizard-arrow flaticon2-next"></i>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav-->

        <!--begin: Wizard Body-->
        <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
          <div class="col-xl-12 col-xxl-7">
            <!--begin: Wizard Form-->
            <form class="form" id="kt_form">
              <!--begin: Wizard Step 1-->
              <div
                class="pb-5"
                data-wizard-type="step-content"
                data-wizard-state="current"
              >
                <h3 class="mb-10 font-weight-bold text-dark">
                  填写您的认证资料
                </h3>
                <div class="form-group">
                  <label>真实姓名</label>
                  <input
                    type="text"
                    class="form-control form-control-solid form-control-lg"
                    name="name"
                    v-model="certifyForm.cert_name"
                  />
                  <span class="form-text text-muted"
                    >请填写您本人的真实姓名，否则无法验证通过。</span
                  >
                </div>
                <div class="form-group">
                  <label>身份证号码</label>
                  <input
                    type="text"
                    class="form-control form-control-solid form-control-lg"
                    name="code"
                    v-model="certifyForm.cert_no"
                  />
                  <span class="form-text text-muted"
                    >请填写您本人的真实身份证号码，否则无法验证通过。</span
                  >
                </div>
              </div>
              <!--end: Wizard Step 1-->

              <!--begin: Wizard Step 2-->
              <div class="pb-5" data-wizard-type="step-content">
                <h4 class="mb-10 font-weight-bold text-dark">
                  请确认您的认证信息
                </h4>
                <div class="form-group">
                  <label class="font-size-h5-md"
                    >真实姓名：{{ certifyForm.cert_name }}</label
                  >
                </div>
                <div class="form-group">
                  <label class="font-size-h5-md"
                    >身份证号码：{{ certifyForm.cert_no }}</label
                  >
                </div>
                <div class="form-group">
                  <span
                    ><span class="text-danger font-weight-bold"
                      >首次实名认证免费</span
                    >，之后<span class="text-warning font-weight-bold"
                      >2元/次</span
                    ></span
                  ><span v-if="currentUser.first_request_verify"
                    >，当前有效的实名认证次数：1</span
                  >
                  <span v-else>，当前有效的实名认证次数：0</span>
                  <Recharge v-bind:dialog.sync="rechargeDialog"></Recharge>
                </div>
              </div>
              <!--end: Wizard Step 2-->

              <!--begin: Wizard Step 3-->
              <div class="pb-5" data-wizard-type="step-content">
                <h4 class="mb-10 font-weight-bold text-dark">
                  打开<span class="text-primary">支付宝</span
                  >扫描二维码完成实名身份验证
                </h4>
                <div class="form-group">
                  <b-img :src="qrcode"></b-img>
                  <br />
                  <span class="mb-10 font-size-h2">
                    请在<span class="text-danger">{{ time }}</span
                    >内完成实名认证
                  </span>
                  <br />
                  <span class="mb-10">
                    实名认证完成后,请稍等几秒钟,页面将会自动跳转，或者点击下方的完成按钮。
                  </span>
                </div>
              </div>
              <!--end: Wizard Step 3-->

              <!--begin: Wizard Actions -->
              <div class="d-flex justify-content-between border-top pt-10">
                <div class="mr-2">
                  <button
                    class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                    data-wizard-type="action-prev"
                    :disabled="disabled"
                  >
                    上一步
                  </button>
                </div>
                <div>
                  <button
                    v-on:click="submit"
                    class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                    data-wizard-type="action-submit"
                  >
                    完成
                  </button>
                  <button
                    class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                    data-wizard-type="action-next"
                    @click="nextStep"
                  >
                    下一步
                  </button>
                </div>
              </div>
              <!--end: Wizard Actions -->
            </form>
            <!--end: Wizard Form-->
          </div>
        </div>
        <!--end: Wizard Body-->
      </div>
    </div>
    <!--end: Wizard-->
    <div v-else>
      <div class="card-header py-3">
        <div class="card-title align-items-start flex-column">
          <h3 class="card-label font-weight-bolder text-dark">实名认证</h3>
          <span class="text-muted font-weight-bold font-size-sm mt-1"
            >填写您的身份证信息</span
          >
        </div>
      </div>

      <div class="card-body p-0">
        <div class="alert alert-success" role="alert">
          恭喜您已通过蜜蜂代理实名认证！
          <a
            class="btn btn-sm btn-primary font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1"
            @click="testServiceDialog = true"
            >立即免费试用</a
          >
        </div>
      </div>
    </div>

    <TestService v-bind:dialog.sync="testServiceDialog"></TestService>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import Recharge from "@/view/pages/pay/Recharge";
import TestService from "@/view/pages/pay/TestService";
import { mapGetters } from "vuex";
import { aliyunUserCertify, aliyunUserCertifyNotify } from "@/api/aliyun";

export default {
  name: "Wizard-1",
  components: { Recharge, TestService },
  computed: {
    ...mapGetters(["currentUserBalance", "currentUser"]),
  },
  data() {
    return {
      wizard: "",
      certify_id: "",
      certifyForm: {
        cert_name: "",
        cert_no: "",
      },
      rechargeDialog: false,
      qrcode: "",
      timer: "",
      second: 1800,
      today: "",
      time: "",
      disabled: false,
      testServiceDialog: false,
    };
  },
  mounted() {
    if (!this.currentUser.is_verify) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Wizard" },
        { title: "Wizard-1" },
      ]);

      // Initialize form wizard
      this.wizard = new KTWizard("kt_wizard_v1", {
        startStep: 1, // initial active step number
        clickableSteps: false, // allow step clicking
      });

      // Validation before going to next page
      this.wizard.on("beforeNext", function (/*wizardObj*/) {
        // validate the form and use below function to stop the wizard's step
        // wizardObj.stop();
      });

      // Change event
      this.wizard.on("change", function (/*wizardObj*/) {
        setTimeout(() => {
          KTUtil.scrollTop();
        }, 500);
      });
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    submit: function (e) {
      e.preventDefault();
      aliyunUserCertifyNotify({ certify_id: this.certify_id }).then((res) => {
        if (res.status === 1) {
          Swal.fire({
            title: "实名认证验证成功",
            text: "",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
          });
          clearInterval(this.timer);
        } else {
          Swal.fire({
            title: "实名认证验证失败",
            text: "",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
        }
      });
    },
    openRecharge() {
      this.rechargeDialog = true;
    },
    nextStep: function (e) {
      let text;
      if (this.wizard.currentStep === 2) {
        this.wizard.stop();
        e.stopPropagation();
        if (this.currentUser["first_request_verify"]) {
          text =
            "首次实名认证免费，请确保支付宝所属人、身份证号完全匹配，否则会导致认证失败。确认提交认证？?";
        } else {
          text =
            "本次实名认证需要扣除2.00元认证费用，认证费用不予退还。请确保支付宝所属人、身份证号完全匹配，否则会导致认证失败。确认提交认证？?";
        }
        Swal.fire({
          title: "认证确认",
          text: text,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "确认提交",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.value) {
            this.disabled = true;
            aliyunUserCertify(this.certifyForm).then((res) => {
              this.wizard.goNext();
              this.qrcode = res.qrcode;
              this.certify_id = res.certify_id;
              this.timer = setInterval(() => {
                aliyunUserCertifyNotify({ certify_id: res.certify_id }).then(
                  (res) => {
                    this.second--;
                    const time = this.$moment.duration(this.second, "seconds");
                    this.time = time.minutes() + "分钟" + time.seconds() + "秒";
                    if (this.second <= 0) {
                      this.time = "已过期，请重新刷页面";
                      clearInterval(this.timer);
                    }

                    if (res.status === 1) {
                      clearInterval(this.timer);
                      Swal.fire({
                        title: "实名认证验证成功",
                        text: "",
                        icon: "success",
                        confirmButtonClass: "btn btn-secondary",
                      });
                      setTimeout(function () {
                        location.reload();
                      }, 2000);
                    }
                  }
                );
              }, 2000);
            });
          }
        });
      }
    },
  },
};
</script>
